var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mgl-map-wrapper"},[_c('div',{ref:"container"})])}
var staticRenderFns = []

export { render, staticRenderFns }